import { render, staticRenderFns } from "./RequestRevision.vue?vue&type=template&id=2ca3a3cc"
import script from "./RequestRevision.vue?vue&type=script&lang=js"
export * from "./RequestRevision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports